import React from 'react';
import { HashRouter } from 'react-router-dom';
import { connect } from 'react-redux';
 
import Home from './components/home/Home';
import { verifyUserStatus } from './components/login/SesionService';
import { BlockedRedirectAlert } from './components/seguridad/SafeRedirectComponent';
 
import './assets/styles/styles.min.css';
import './styles/material-icons/Material-Icons.css';
import './assets/sass/master.scss';
import './App.css';
 
class App extends React.Component {
  constructor(props) {
    super(props);
    this.props.verifyUserStatus();
  }
 
  render() {
    return (
      <HashRouter>
        <Home />
        <BlockedRedirectAlert />
      </HashRouter>
    );
  }
}
 
const mapStateToProps = state => ({
  sessionData: state.sessionData
});
 
const mapDispatchToProps = dispatch => ({
  verifyUserStatus: value => dispatch(verifyUserStatus(value))
});
 
export default connect(mapStateToProps, mapDispatchToProps)(App);
 